module.exports = __webpack_public_path__ + "542bb8a6fee089d593eb4add3400a37e.png";